export { EventDetailGroupDisplay } from "./EventDetailGroupDisplay";
